import { useEffect } from 'react';

import { analytics } from 'app/providers/AnalyticsProvider/analytics';
import { useAppSelector } from 'shared/hooks/store';

import type { Analytics } from 'app/providers/AnalyticsProvider/types';

export const useAnalyticsInitialization = (): Analytics => {
  const { enabled } = useAppSelector(state => state.analytics);

  useEffect(() => {
    if (enabled) {
      analytics.init();
    }
  }, [enabled]);

  return analytics;
};
